import React from "react";
import { ArrowRight } from "lucide-react";
import { AuthCard } from "@/components/landing/AuthCard";
import { GreenButton, GhostButton, scrollToId } from "@/components/landing/LandingHeader";

export const LandingHero = ({ mode, setMode, nextTab, nextName, onFree }) => (
  <section data-testid="lp-hero" className="relative overflow-hidden">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_20%_10%,rgba(34,211,238,0.16),transparent_55%),radial-gradient(ellipse_at_90%_60%,rgba(30,64,175,0.35),transparent_60%)]" />
    <div className="lp-dots pointer-events-none absolute inset-0 opacity-60" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 pb-20 pt-14 sm:px-6 lg:grid-cols-[1.25fr_1fr] lg:items-center lg:pb-28 lg:pt-20">
      <div className="lp-rise">
        <p data-testid="lp-eyebrow" className="font-mono text-[11px] font-semibold uppercase tracking-[0.35em] text-[#22D3EE]">Sports intelligence. One platform.</p>
        <h1 data-testid="lp-headline" className="mt-5 font-condensed text-5xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-6xl lg:text-[5.5rem]">
          The edge isn’t luck.<br /><span className="text-[#22D3EE] drop-shadow-[0_0_24px_rgba(34,211,238,0.35)]">It’s data.</span>
        </h1>
        <p className="mt-6 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
          One platform. Every dashboard. Deeper insights across sports. Discover player matchups, scoring trends, goalie weaknesses, game environments, and analytical tools built to help you research the edge.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <GreenButton data-testid="lp-hero-free" onClick={onFree}>Get Hat Trick Free <ArrowRight className="h-4 w-4" /></GreenButton>
          <GhostButton data-testid="lp-hero-explore" onClick={() => scrollToId("dashboards")}>Explore All Dashboards</GhostButton>
        </div>
        <p data-testid="lp-availability" className="mt-5 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">
          <span className="h-1.5 w-1.5 rounded-full bg-[#22D3EE] shadow-[0_0_10px_#22D3EE]" /> Free access available now
        </p>
      </div>
      <div id="access" className="lp-rise scroll-mt-24 [animation-delay:150ms]">
        <AuthCard mode={mode} setMode={setMode} nextTab={nextTab} accent="green"
          note={nextName ? `Sign in or create a free account to open ${nextName}` : undefined} />
      </div>
    </div>
  </section>
);
